export const BREAK_POINTS = {
  MIN: {
    LARGE_2X: '1510px',
    LARGE_1X: '1366px',
    TABLET: '1025px',
    PHONE: '768px',
    PHONE_PORTRAIT: '416px',
    PHONE_MINIMUM: '280px',
  },
  MAX: {
    MAX: '9999px',
    LARGE_2X: '1509px',
    LARGE_1X: '1365px', // Ipad Pro horizontal has 1366px width
    TABLET: '1024px',
    PHONE: '767px',
    PHONE_PORTRAIT: '415px',
  },
};

// TODO (abdulbasid) Fix the table width pixel on DRSKTOP_1X and TABLET

export const TABLE_WIDTHS = {
  DESKTOP_3X: 2000, // If min column count 13
  DESKTOP_2X: 1200, // If mi column count 11
  DESKTOP_1X: 998, // If mi column count 7
  TABLET: 898,
};

export const MODAL_VIEW = {
  BIG: '80vh',
  MIDDLE: '60vh',
  AUTO: 'auto',
};

export const EXPIRE_DATE_RANGE = {
  past: 0,
  future: 30,
};

export enum YES_NO {
  YES = '1',
  NO = '0',
}

export enum IS_PROVIDED {
  PROVIDED = '1',
  NOT_PROVIDED = '0',
}

export const MINIMUM_DATE_CONTROL = new Date(1900, 0, 1);

export const LOGIN_ERROR_CODES = [5, 18, 19];
export const CAPTCHA_ERROR_CODE = 10;
export const JWT_ERROR_CODE = 8;
export const INVALID_SESSION_ERROR_CODE = 7;
export const INVALID_FILE_ERROR = 13;
export const INVALID_TAX_NUMBER = 300142;
export const MISSING_INN_NUMBER = 1040146;
export const INVALID_INN_NUMBER = 1040147;

export const ERR_SIFRE_NUMERIK = 95295;
export const ERR_SIFRE_TEKRAR = 95078;
export const ERR_ESKI_SIFRE = 95080;
export const ERR_KISA_SIFRE = 95081;
export const ERR_YENI_SIFRE = 95082;
export const ERR_SIFRE_HATA = 95083;

export const UNSUPPORTED_BROWSER = 'ie';
export const SUPPORTED_BROWSERS = [
  'Google Chrome',
  'Microsoft Edge',
  'Mozilla Firefox',
  'Apple Safari',
  'Opera',
];

export enum CARD_STATUS {
  NEW_CARD = 'B',
}

export const CARD_APPLICATON_STATUS = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export enum TABLE_ACTION {
  ADD = 1,
  EDIT = 0,
}
